import styled from 'styled-components';

export const PreviewImageBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    background: ${({ theme }) => theme.modal.overlayColor};
`;

export const PreviewImageContainer = styled.div`
    width: 80%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
`;

export const PreviewImageStyled = styled.img`
    display: block;
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    position: relative;
`;
